import { NavLink } from 'react-router';
import { useMediaQuery } from 'react-responsive';
import { GraduationCap, BarChart3, LayoutDashboard, Users } from 'lucide-react';
import Alex from '/z30-images/robot-s.png';
import { useHelpChat } from './HelpChatProvider';

const navItems = [
  { path: '/app', label: 'Dashboard', icon: LayoutDashboard, tourId: 'dashboard', end: true },
  { path: '/app/lessons', label: 'Plan', icon: GraduationCap, tourId: 'my-plan' },
  { path: '/app/reports', label: 'Reports', icon: BarChart3, tourId: 'reports' },
  { path: '/app/profiles', label: 'Profiles', icon: Users, tourId: 'profiles' },
];

export function BottomNavigation() {
  const isMobile = useMediaQuery({ query: '(max-width: 639px)' });
  const { isOpen, toggle } = useHelpChat();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 flex h-16 border-t border-gray-200 sm:hidden">
      <div className="flex min-w-0 flex-[4] items-center justify-around bg-white">
        {navItems.map(({ path, label, icon: Icon, tourId, end }) => (
          <NavLink
            key={path}
            to={path}
            end={end}
            data-tour={isMobile && tourId ? tourId : undefined}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center px-2 py-1 text-xs transition-colors ${
                isActive
                  ? 'text-action-blue'
                  : 'text-gray-500 hover:text-gray-700'
              }`
            }
          >
            <Icon size={20} className="mb-1" />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
      <button
        type="button"
        onClick={toggle}
        data-tour="help-agent"
        className={`flex min-w-0 flex-[1] flex-col items-center justify-center bg-white text-xs transition-colors hover:bg-gray-50 ${
          isOpen ? 'text-action-blue' : 'text-gray-700'
        }`}
        aria-label={isOpen ? 'Close chat' : 'Open help'}
        aria-pressed={isOpen}
      >
        <img src={Alex} alt="Alex" className="mb-1 h-8 w-8 object-contain" />
        <span>Help</span>
      </button>
    </nav>
  );
}
